import { ShrinkOutlined } from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';
import { ReactNode, useState } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import useElementHeight from '@app/hooks/useElementHeight';

type Props = {
  description: ReactNode;
};

const { Title } = Typography;

const BoatDescription = ({ description }: Props) => {
  const [elementRef, height] = useElementHeight();

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  return (
    <div className={styles.container}>
      <Space direction="vertical" size={16} className={styles.wrapDesc}>
        <Title level={2} className={styles.descTitle}>
          Boat Description
        </Title>

        <div className={cn(isExpanded ? styles.expand : styles.collapsed, styles.description)}>
          <div
            ref={elementRef}
            className={styles.paragraph}
            dangerouslySetInnerHTML={{
              __html: `${description}`,
            }}
          />
          {height > 260 ? (
            isExpanded ? (
              <Button
                type="link"
                onClick={toggleExpand}
                className={cn(isExpanded ? styles.moreCollapsed : styles.readMore)}
              >
                <ShrinkOutlined /> Collapse
              </Button>
            ) : (
              <Button type="link" onClick={toggleExpand} className={styles.readMore}>
                ...Read more
              </Button>
            )
          ) : null}
        </div>
      </Space>
    </div>
  );
};

export default BoatDescription;
